import { cryptoInstance } from '@/public/fetch/index';
import { orderApi2 } from '@/public/utils/basePath';
import { userApi2 } from '@/public/utils/basePath';
const baseURL = orderApi2;
const userURL = userApi2;
// 发票内容
export const getInvoiceContent = (params) => {
    return cryptoInstance.get('/client/invoice/content/list', {
        baseURL,
        params
    });
};
// 新增发票模板
export const addInvoice = (params) => {
    return cryptoInstance.post('/client/invoice/template/add', params, {
        baseURL
    });
};
// 发票模板列表
export const getInvoiceList = (params) => {
    return cryptoInstance.get('/client/invoice/template/list', {
        baseURL,
        params
    });
};
// 地址列表
export const getAddressList = (params) => {
    return cryptoInstance.get('/client/invoice/address/list', {
        baseURL,
        params
    });
};
// 根据用户ID默认选择地址
export const defaultDetail = () => {
    return cryptoInstance.get('/client/invoice/address/defaultDetail', {
        baseURL
    });
};
// 删除地址
export const addressDelete = (params) => {
    return cryptoInstance.get('/client/invoice/address/delete', {
        baseURL,
        params
    });
};
// 发票地址详情查询
export const addressDeatil = (params) => {
    return cryptoInstance.get('/client/invoice/address/detail', {
        baseURL,
        params
    });
};
// 我的-发票列表
export const invoiceList = (params) => {
    return cryptoInstance.get('/client/invoice/user/list', {
        baseURL,
        params
    });
};
// 发票详情
export const invoiceDetail = (params) => {
    return cryptoInstance.get('/client/invoice/user/detail', {
        baseURL,
        params
    });
};
// 发票模版详情查询
export const templateDetail = (params) => {
    return cryptoInstance.get('/client/invoice/template/detail', {
        baseURL,
        params
    });
};
// 发票申请
export const applyInvoice = (params) => {
    return cryptoInstance.post('/client/invoice/apply/add', params, {
        baseURL
    });
};
// 修改发票模版
export const updataInvoice = (params) => {
    return cryptoInstance.post('/client/invoice/template/update', params, {
        baseURL
    });
};
// 根据用户ID选择默认发票模版详情
export const detailByUserId = () => {
    return cryptoInstance.get('/client/invoice/template/detailByUserId', {
        baseURL,
    });
};
// 发票发送到邮箱
export const sendEmail = ({ params, query }) => {
    return cryptoInstance.get(`/v2/user/invoice/send_invoice_file/${params.module}/${params.invoiceId}`, {
        baseURL: userURL,
        params: query
    });
};
// 发票订单信息根据订单ID和订单类型查询
export const orderDetail = (params) => {
    return cryptoInstance.get('/client/invoice/order/detail', {
        baseURL,
        params
    });
};
